export default {
  headers: [
    ['satellite-tracking/report.availability_status_report_vehicle', 'vehicle'],
    ['satellite-tracking/report.availability_status_report_status', 'vehicle_status'],
    ['satellite-tracking/report.availability_status_report_duration', 'duration'],
    ['satellite-tracking/report.availability_status_report_duration_date_start', 'day_start'],
    ['satellite-tracking/report.availability_status_report_duration_date_end', 'day_end']
  ]
}
